import { FieldErrors } from 'react-hook-form';
import { IFormState, IFieldElement, IScheme } from '../types/calculator';

interface IEnrichedError {
  field: keyof IFormState;
  message: string;
  label: string;
}

/**
 * Тулза для обогащения события ошибок, обогащает событие следующими полями
 * @label - текстовое название поля для рендера на лендинге
 * */

export const getEnrichedErrors = (errors: FieldErrors<IFormState>, formScheme: IScheme[]) => {
  const formElements = formScheme[0].elements as IFieldElement[];

  const data = Object.entries(errors).map(([key, value]) => {
    const element = formElements.find(el => el.name === key);

    return {
      field: key,
      label: element ? element.label : '',
      message: value.message,
    };
  });

  return data as IEnrichedError[];
};
